<div class="legal-notice">
    <p *ngIf="currentLanguage === 'ru'">{{ TEXTS.LOGIN_WINDOWS.licenseStr1 }}</p>
    <p *ngIf="currentLanguage === 'ru'">{{ TEXTS.LOGIN_WINDOWS.licenseStr2 }}</p>
    <div class="text_policy"><a href="{{TEXTS.PROFILE.privicyPolicy.url}}" target="_blank">{{ TEXTS.PROFILE.privicyPolicy.text }}</a></div>
    <p *ngIf="currentLanguage === 'ru'">{{ TEXTS.LOGIN_WINDOWS.licenseStr3 }}</p>
</div>
